import { Button, Spinner } from 'react-bootstrap'
import { useTranslation } from 'react-i18next'
import useUserContext from 'shared/users/contexts/useUserContext'
import { getEnabledCountriesForEnvironment } from 'features/declaration/codelist/api/useCodelist'
import useSerbianInboundFetch from './useSerbianInboundFetch'

function isSerbiaAvailable() {
  return getEnabledCountriesForEnvironment().includes('RS')
}

function SerbianInboundFetchControl() {
  const { t } = useTranslation()
  const { step, progress, start } = useSerbianInboundFetch()

  return (
    <Button
      data-testid="serbian-inbound-fetch-button"
      variant="outline-dark"
      size="sm"
      className="ms-2"
      disabled={step !== 'IDLE'}
      onClick={start}
    >
      {step !== 'IDLE' && <Spinner animation="border" size="sm" className="me-2" />}
      {step === 'SIGNING' && progress
        ? t('serbiaInboundFetch.signing', { done: progress.done, total: progress.total })
        : t('serbiaInboundFetch.button')}
    </Button>
  )
}

/**
 * The administrator's manual fetch of Serbian customs replies, a workaround offered only where the
 * Serbian connector is configured (the test environment) and only to administrators.
 */
function SerbianInboundFetchButton() {
  const { isAdmin } = useUserContext()

  if (!isAdmin || !isSerbiaAvailable()) {
    return null
  }

  return <SerbianInboundFetchControl />
}

export default SerbianInboundFetchButton
